import React, {useState, useEffect, useContext} from "react";
import cn from "classnames";
import {Link} from "react-router-dom";
import styles from "./Profile.module.sass";
import Icon from "../../components/Icon";
import User from "./User";
import Items from "./Items";
import {get, prepareItems} from "../../adapters/api";
import {useParams} from "react-router";
import Loader from "../../components/Loader";
import {Web3Context} from "../../contexts/Web3Context";
import { message } from 'antd';
message.config({top: 100, duration: 5, maxCount: 3,});

const navLinks = [
  "All Items",
  "On Sale",
];

const Profile = () => {
  const nTypes = {
    0: 'all-my',
    1: 'my-on-sale',
  }

  const [activeIndex, setActiveIndex] = useState(0);
  const [user, setUser] = useState(false);
  const [nft, setNft] = useState(false);
  const [users, setUsers] = useState(false);
  const [nType, setNType] = useState(nTypes[0]);
  const [loadMoreInProcess, setLoadMoreInProcess] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  const [more, setMore] = useState(false);

  const {address} = useParams();

  const {defaultAccount} = useContext(Web3Context);

  const handleMore = () => {
    setMore(true);
    setPage(page + 1)
  }

  useEffect(() => {
    (async () => {
      if (address || defaultAccount) {
        try {
          const userInfo = await get('user/profile?from=' + (address || defaultAccount));
          setUser(userInfo.data);
        } catch (e) {
        }
      }
    })();
  }, [defaultAccount, address]);

  useEffect(() => {
    (async () => {
      if (user) {
        setLoadMoreInProcess(true);
        try {
          const discover = await get('token/discover?type=' + nType + '&from=' + user.address + '&page=' + page);
          console.log('discover', discover);
          if (discover.data) {
            let items = prepareItems(discover.data.items, discover.data.users);
            if (more) items = nft ? nft.concat(items) : items;
            setNft(items);
            setUsers(discover.data.users);
            setLoadMoreInProcess(false);
            setHasMorePages(discover.data.filters.hasMorePages);
          }
        } catch (e) {
        }
      }
    })();
  }, [nType, page, user, more]);

  return (
    <div className={styles.profile}>
      <div
        className={cn(styles.head)}
        style={{
          backgroundImage: "url(/images/content/bg-profile.jpg)",
        }}
      >
        <div className={cn("container", styles.container)}>
          <div className={styles.btns}>
            <Link
              className={cn("button-stroke button-small", styles.button)}
              to="/profile-edit"
            >
              <span>Edit profile</span>
              <Icon name="image" size="16"/>
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.body}>
        <div className={cn("container", styles.container)}>
          {user && <User className={styles.user} user={user}/>}
          <div className={styles.wrapper}>
            <div className={styles.nav}>
              {navLinks.map((x, index) => (
                <button
                  className={cn(styles.link, { [styles.active]: index === activeIndex, })}
                  key={index}
                  onClick={() => {
                    setActiveIndex(index);
                    setNType(nTypes[index]);
                  }}
                >
                  {x}
                </button>
              ))}
            </div>
            <div className={styles.group}>
              <div className={styles.item}>
                {nft && <Items class={styles.items} items={nft} users={users}/>}
                <div className={styles.btns}>
                  {hasMorePages && !loadMoreInProcess &&
                  <button className={cn("button-stroke", styles.button)} onClick={handleMore}>
                    <span>Load more</span>
                  </button>
                  }
                </div>
                {loadMoreInProcess && <Loader className={styles.loader}/>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
